import { useCallback } from 'react'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'

export const useOAuthApps = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account, isLoading: accountIsLoading } = useGetAccountQuery({ accountId })
  const isOAuthAppAllowed = useCallback(
    (oauthAppId: string): boolean => {
      const restrictions = account?.data?.enterpriseConfig.integrationsConfig.restrictions
      if (restrictions && (restrictions.allowedIntegrations?.length || restrictions.deniedIntegrations?.length)) {
        if (restrictions.allowedIntegrations?.length) {
          return restrictions.allowedIntegrations.includes(oauthAppId) && !restrictions.deniedIntegrations.includes(oauthAppId)
        }
        return !restrictions.deniedIntegrations.includes(oauthAppId)
      }
      return true
    },
    [account],
  )

  return {
    isOAuthAppAllowed,
    accountIsLoading,
  }
}
